import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject, Renderer2, inject } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { AfterContentInitDirective } from '@df/ui/common/after-content-init.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { LocalStickyPanelDirective } from '../../../../ui/sticky/sticky-panel.directive';
export interface IPageComponentGuideItem {
    title: string;
    anchorId: string;
}
export interface IPageComponentGuideData extends NICmsContentComponent.IData {
    headingLine1?: string;
    headingLine2?: string;
    itemsTitle: string;
    items?: IPageComponentGuideItem[];
    components: NICmsContentComponent.IData[];
}
@ICmsComponent<PageComponentGuideComponent>({
    id: 'guide',
    name: 'Guide',
    tags: ['guide'],
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'headingLine1',
            title: 'Heading Line 1'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'headingLine2',
            title: 'Heading Line 2'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'itemsTitle',
            title: 'Items Title',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Item',
            itemName: 'item',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'anchorId',
                    title: 'Anchor ID',
                    reqiuired: true
                }
            ]
        },
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'component',
            default: []
        }
    ]
})
@Component({
    selector: 'page-component-guide',
    templateUrl: './guide.html',
    styleUrls: ['guide.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ICmsClientModule, GridModule, LocalStickyPanelDirective, AfterContentInitDirective]
})
export class PageComponentGuideComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentGuideData;

    private scrollToService = inject(ScrollToService);
    constructor(
        @Inject(DOCUMENT)
        private document: Document,
        protected elementRef: ElementRef,
        protected renderer2: Renderer2
    ) {
        super();
    }
    sidebarHidden = this.client.isM || this.client.isS;
    activeAnchorId: string | undefined;
    scrollToId(id: string): void {
        const element = this.document.body.querySelector('#' + id);
        if (element) {
            if (this.client.isX || this.client.isL) {
                this.scrollToService.scrollTo(element, { offset: 80 });
            } else {
                this.activeAnchorId = id;
                this.detectChanges();
                this.timeoutService.setTimeout(() => {
                    this.toggleSidebar();
                    this.activeAnchorId = undefined;
                    this.scrollToService.scrollTo(element, { offset: 470 });
                }, 500);
            }
        }
    }
    toggleSidebar(): void {
        this.sidebarHidden = !this.sidebarHidden;
        this.detectChanges();
    }
}
